export enum LocationType {
    Local, Country, International
}
